import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./Style/ConfirmAssessment.css";
import Loading from "../../Common/Loading";
import bg from "./Image/blank_background.png";

type RenderData = {
  logged_name: string;
  lblGrades: string;
  lblYear: string;
  spanGrades: string;
  logo_class: string;
};

export default function ConfirmAssessment() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [renderData, setRenderData] = useState<RenderData | null>(null);
  const [error, setError] = useState<string | null>(null);

  // Initial values from URL
  const initialReportNo = searchParams.get("ReportNo") || "0";
  const initialCalledFrom = searchParams.get("CalledFrom") || "";

  // Real states updated by backend
  const [reportNo, setReportNo] = useState(initialReportNo);
  const [calledFrom, setCalledFrom] = useState(initialCalledFrom);

  const apiUrl =
    process.env.REACT_APP_DOCUMENT_LINK ;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const school_code = sessionStorage.getItem("SchoolCode");
        const family_code = sessionStorage.getItem("FamilyCode");
        const login = sessionStorage.getItem("Login");

        const url = `${apiUrl}confirm-assessment/`;

        const res = await fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            school_code,
            family_code,
            login,
            report_no: initialReportNo,
            called_from: initialCalledFrom,
          }),
        });

        const payload = await res.json();
        // console.log("API Payload:", payload);

        // ---------- REDIRECT CASE ----------
        if (payload.action === "redirect") {
          // console.log("Received redirect:", payload);

          // Always set report no BEFORE redirect
          if (payload?.data?.report_no) {
            setReportNo(String(payload.data.report_no));
          }
          if (payload?.data?.called_from) {
            setCalledFrom(payload.data.called_from);
          }

          window.location.href = payload.url;
          return;
        }

        if (payload.action === "render") {
          // console.log("Rendering data:", payload.data);

          setRenderData(payload.data);

          if (payload?.data?.report_no) {
            setReportNo(String(payload.data.report_no));
          }

          if (payload.called_from) {
            setCalledFrom(payload.called_from);
          }
        }
      } catch (err) {
        console.error(err);
        setError("Failed to load data.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const onReady = () => {
    // console.log("Final ReportNo:", reportNo);

    const qs = `?ReportNo=${encodeURIComponent(
      reportNo
    )}&CalledFrom=${encodeURIComponent(calledFrom)}`;
  

    navigate(`/MathsDoctor/Assessment/Assessment${qs}`);
  };


  const onLogout = () => {
    const target = calledFrom || "/";
    // console.log("Logging out, redirecting to:", target);
    window.location.href = "/STUDENT/MSR/StudyRoom";
  };

  if (loading) {
    return (
      <div className="loader_overlay">
        <Loading />
      </div>
    );
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  if (!renderData) {
    return <div>No data to render.</div>;
  }

  return (
    <div
      style={{
        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "absolute",
        width: "100vw",
        height: "100vh",
      }}
    >
      <div id="Form" style={{ backgroundImage: `url(${bg})` }}>
        <div id="instructions_container">
          <button className="sign_out" onClick={onLogout} aria-label="Logout" />
          <div id="divLoggedName">{renderData.logged_name}</div>
        </div>

        <div id="instructions_content_box">
          <div id="instructions_content">
            <div id="rocket_image" />
            <div id="instructions_text_box">
              <p className="instructions_title">GET READY!</p>

              <p className="instructions_text">
                <br />
                Allow <span className="instructions_orange">30 minutes</span> to
                complete the assessment for{" "}
                <strong>{renderData.lblGrades}</strong> and below.
                <br />
                Allow <span className="instructions_orange">45 minutes</span>{" "}
                for <strong>{renderData.lblYear}</strong> and above.
                <br />
                <br />
                If your internet connection drops or you need to stop the test,
                <br className="line_break" />
                you can{" "}
                <span className="instructions_orange">resume at any time</span>.
                <br />
                <br />
                Only students in{" "}
                <span id="spanGrades" className="instructions_orange">
                  {renderData.spanGrades}
                </span>
                .
                <br />
                <br />
                Have a{" "}
                <span className="instructions_orange">pen and paper</span>{" "}
                handy for questions that require workings.
                <br />
                <br />
              </p>

              <button
                className="im_ready_btn"
                onClick={onReady}
                aria-label="I'm Ready"
              />
              <div id="divLogo" className={renderData.logo_class} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
